import * as ActionTypes from '../../actions/allActions'
import { currentUserNormalizer } from '../../normalizers/Normalizers'

const currentUserInit = {}
const currentUser = (state = currentUserInit, action) => {
	switch (action.type) {
		case ActionTypes.SIGNIN_SUCCESS:
		case ActionTypes.CHECKTOKEN_SUCCESS:
		case ActionTypes.ACCOUNT_PROFILE_SUCCESS:
		case ActionTypes.FETCH_ACCOUNT_PROFILE_SUCCESS:
			return currentUserNormalizer(action.data.data)
		case ActionTypes.LOGOUT:
			return currentUserInit
		default:
			return state
	}
}

export default currentUser


// WEBPACK FOOTER //
// ./src/reducers/data/currentUser.js